import { render, staticRenderFns } from "./ToolError.vue?vue&type=template&id=ba1bb5b6&"
import script from "./ToolError.vue?vue&type=script&lang=js&"
export * from "./ToolError.vue?vue&type=script&lang=js&"
import style0 from "./ToolError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports